import { useState, useEffect } from 'react';
import { Heading, Alert, Button, View, Link, Text } from '@instructure/ui';
import RoomList from './RoomList';
import useAppStore from '../../stores/app';
import { getRooms } from '../../lib/api';
import PageLoader from '../../helpers/loader';
import HeaderBar from '../../components/HeaderBar';

const Rooms = () => {
  const setRoomSid = useAppStore((state) => state.setRoomSid);
  const [rooms, setRooms] = useState([]);
  const [roomsLoaded, setRoomsLoaded] = useState(false);
  const [locations, setLocations] = useState([]);
  const [expandByDefault, setExpandByDefault] = useState(false);

  useEffect(() => {
    loadRooms();
  }, []);

  const loadRooms = async () => {
    setRoomsLoaded(false);
    const roomResult = await getRooms();
    if (roomResult.successful) {
      setRooms(roomResult.data.rooms);
      setLocations(roomResult.data.locations);
      // if there is only one room, expand the toggle group by default...
      if (roomResult.data.locations.length === 1) {
        setExpandByDefault(true);
      }
    } else {
      // TODO: Add error handling
    }
    setRoomsLoaded(true);
  };

  return (
    <>
      {roomsLoaded ? (
        <View as="div" >
          <View as="div">
            <HeaderBar />
          </View>

          <View as="div" margin="large none none none" height="calc(100vh - 120px)" overflowY="auto">
            <View
              as="div"
              width="800px"
              margin="0 auto"
              textAlign="center"
            >
              <Heading>Proctor Rooms</Heading>

              <View as="div" padding="small" width="100%">
                <View as="div" textAlign="end">
                  <Text variant="legend">
                    <Link color="primary" margin="small" onClick={() => loadRooms()}>Refresh List</Link>
                  </Text>
                </View>
                {locations.length > 0 ? (
                  <RoomList locations={locations} rooms={rooms} />
                ) : (
                  <Alert variant="info" margin="small">
                    This account has no rooms to join.
                  </Alert>
                )}
              </View>
            </View>

          </View>
        </View>
      ) : (
        <PageLoader text="Loading rooms..." />
      )}
    </>
  );
};

export default Rooms;
